import { render, staticRenderFns } from "./mncs-procurement-team.vue?vue&type=template&id=1c4f3dcc&"
import script from "./mncs-procurement-team.vue?vue&type=script&lang=js&"
export * from "./mncs-procurement-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4f3dcc')) {
      api.createRecord('1c4f3dcc', component.options)
    } else {
      api.reload('1c4f3dcc', component.options)
    }
    module.hot.accept("./mncs-procurement-team.vue?vue&type=template&id=1c4f3dcc&", function () {
      api.rerender('1c4f3dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/mncs-procurement-team.vue"
export default component.exports